import { createFileRoute } from '@tanstack/react-router';
import { GuiaAfipPage } from '@/components/GuiaAfipPage';

export const Route = createFileRoute('/_authenticated/guia-afip')({
  component: GuiaAfipPage,
});
